(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zinko-grid-view"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zinko-grid-view')) {
 customElements.define('zinko-grid-view', class extends HTMLElement {
  connectedCallback() {
   this.screen = matchMedia('(min-width:990px)');
   this.update = value => {
    const allowed = this.screen.matches ? ['2','3','4','6'] : ['1','2','3'];
    if (!allowed.includes(value)) value = this.screen.matches ? '4' : '2';
    document.documentElement.dataset.zinkoGrid = value;
    this.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.columns === value)));
   };
   this.restore = () => {
    let value;
    try { value = sessionStorage.getItem(this.screen.matches ? 'zinko-grid-desktop' : 'zinko-grid-mobile'); } catch (error) {}
    this.update(value);
   };
   this.restore();
   this.screen.addEventListener('change', this.restore);
   this.onclick = event => {
    const button = event.target.closest('button[data-columns]');
    if (!button) return;
    this.update(button.dataset.columns);
    try { sessionStorage.setItem(this.screen.matches ? 'zinko-grid-desktop' : 'zinko-grid-mobile', button.dataset.columns); } catch (error) {}
   };
  }
  disconnectedCallback() {
   this.screen.removeEventListener('change', this.restore);
  }
 });
}
if (!window.zinkoCollectionReturn) {
 window.zinkoCollectionReturn = true;
 const positionKey = () => 'zinko-collection-position:' + location.pathname + location.search;
 const savePosition = () => {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;
  const cards = Array.from(grid.children);
  const card = cards.find(item => item.getBoundingClientRect().bottom > 0);
  const link = card && card.querySelector('a[href*="/products/"]');
  try {
   sessionStorage.setItem(positionKey(), JSON.stringify({
    y: window.scrollY,
    href: link && link.getAttribute('href'),
    top: card && card.getBoundingClientRect().top
   }));
  } catch (error) {}
 };
 document.addEventListener('click', event => {
  const link = event.target.closest('a[href*="/products/"]');
  if (link && link.closest('#product-grid')) savePosition();
 }, true);
 window.addEventListener('pagehide', savePosition);
 window.addEventListener('pageshow', event => {
  const navigation = performance.getEntriesByType('navigation')[0];
  if (!event.persisted && (!navigation || navigation.type !== 'back_forward')) return;
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(positionKey())); } catch (error) {}
  if (!saved || !Number.isFinite(saved.y)) return;
  let cancelled = false;
  const cancel = () => { cancelled = true; };
  window.addEventListener('wheel', cancel, {once:true, passive:true});
  window.addEventListener('touchstart', cancel, {once:true, passive:true});
  window.addEventListener('keydown', cancel, {once:true});
  const restore = () => {
   if (cancelled) return;
   const grid = document.querySelector('#product-grid');
   const link = grid && Array.from(grid.querySelectorAll('a[href*="/products/"]')).find(item => item.getAttribute('href') === saved.href);
   const card = link && link.closest('.grid__item');
   const y = card && Number.isFinite(saved.top) ? window.scrollY + card.getBoundingClientRect().top - saved.top : saved.y;
   window.scrollTo({top:y,behavior:'instant'});
  };
  requestAnimationFrame(() => requestAnimationFrame(restore));
  const observer = new ResizeObserver(restore);
  const grid = document.querySelector('#product-grid');
  if (grid) observer.observe(grid);
  setTimeout(() => {
   observer.disconnect();
   window.removeEventListener('wheel', cancel);
   window.removeEventListener('touchstart', cancel);
   window.removeEventListener('keydown', cancel);
  }, 1500);
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zinko-sleeve-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zinko-sleeve-navigation')) {
    customElements.define('zinko-sleeve-navigation', class extends HTMLElement {
      connectedCallback() {
        this.updateLinks = () => {
          const current = new URL(window.location.href);
          this.querySelectorAll('a').forEach(link => {
            if (link.hasAttribute('data-reset-filters') || link.hasAttribute('data-collection-link')) return;
            const url = new URL(link.href);
            url.search = current.search;
            url.searchParams.delete('page');
            link.href = url.href;
          });
        };
        this.updateLinks();
        this.addEventListener('pointerdown', this.updateLinks);
        this.addEventListener('focusin', this.updateLinks);
        this.addEventListener('click', this.updateLinks);
      }
      disconnectedCallback() {
        this.removeEventListener('pointerdown', this.updateLinks);
        this.removeEventListener('focusin', this.updateLinks);
        this.removeEventListener('click', this.updateLinks);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zinko-store-categories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zinko-store-categories')) {
  customElements.define('zinko-store-categories', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.applyLink = this.closest('.mobile-facets__inner').querySelector('[data-category-apply]');
      this.applyLink.addEventListener('click', () => this.updateLink());
      const current = new URLSearchParams(location.search).getAll('filter.p.product_type').flatMap(value => value.split(','));
      this.querySelectorAll('[data-product-type]').forEach(input => { input.checked = current.includes(input.value); });
      this.addEventListener('click', event => {
        const characterLink = event.target.closest('[data-character-link]');
        if (characterLink) {
          const target = new URL(characterLink.getAttribute('href'), location.origin);
          target.search = location.search;
          characterLink.href = target.toString();
        }
        const toggle = event.target.closest('[data-category-toggle]');
        if (toggle && this.contains(toggle)) {
          event.preventDefault();
          event.stopPropagation();
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          if (toggle.parentElement === this) {
            this.querySelector('nav').hidden = expanded;
            this.querySelector('.zinko-category-hint').hidden = expanded;
          } else toggle.nextElementSibling.hidden = expanded;
        }
        if (event.target.closest('[data-category-apply]')) this.updateLink();
      });
      this.addEventListener('input', event => {
        if (event.target.matches('input[type="checkbox"]')) event.stopPropagation();
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type="checkbox"]')) return;
        event.stopPropagation();
        if (event.target.matches('[data-group-all]')) {
          event.target.closest('.zinko-store-category-group').querySelectorAll('[data-product-type]').forEach(input => { input.checked = event.target.checked; });
        }
        this.updateLink();
      });
      this.updateLink();
    }
    updateLink() {
      this.querySelectorAll('.zinko-store-category-group').forEach(group => {
        const inputs = [...group.querySelectorAll('[data-product-type]')];
        const count = inputs.filter(input => input.checked).length;
        const all = group.querySelector('[data-group-all]');
        if (!all) return;
        all.checked = count === inputs.length;
        all.indeterminate = count > 0 && count < inputs.length;
      });
      const url = new URL(this.dataset.baseUrl, location.origin);
      const form = this.closest('form');
      if (form) {
        for (const [key,value] of new FormData(form)) {
          if (value && key !== 'filter.p.product_type' && (key.startsWith('filter.') || key === 'sort_by')) url.searchParams.append(key,value);
        }
      }
      this.querySelectorAll('[data-product-type]:checked').forEach(input => url.searchParams.append('filter.p.product_type',input.value));
      this.applyLink = this.closest('.mobile-facets__inner').querySelector('[data-category-apply]');
      if (this.applyLink) this.applyLink.href = url.toString();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
